import request from '@/utils/request'

// 新增搬运信息
export function addCarry(data) {
  return request({
    url: '/zhixiao/api//authentication/addInfromation',
    method: 'post',
    data
  })
}

// 获取搬运认证结果
export function getAuthResult(params) {
  return request({
    url: '/zhixiao/api//authentication/authInfromation',
    method: 'get',
    params
  })
}

// 获取搬运信息
export function getCarryInfo(params) {
  return request({
    url: '/zhixiao/api/authentication/queryauthInfromation',
    method: 'get',
    params
  })
}
